
import { defineComponent, ref, onMounted } from 'vue';
import BaseLayout from '@/layouts/BaseLayout.vue';
import HeaderBar from '@/components/common/HeaderBar.vue';
import BusInfoCard from '@/components/common/BusInfoCard.vue';
import busHandler from '@/api-handler/bus';
import { useRoute, useRouter } from 'vue-router';
import { IBusRoute,IBusStopOfRoute } from '@/types/api/bus';
import { taiwanCity } from '@/utils/cities';
import { City, ILatLngLiteral } from '@/types/common';
import StopMap from '@/components/common/StopMap.vue';
import BusStopMapDialog from '@/components/common/BusStopMapDialog.vue';
import LoadingPage from '@/components/common/LoadingPage.vue';
import { Toast } from "@/utils/toast-helper";

export default defineComponent({
  name: 'BusStopInfo',
  components: {
    BaseLayout,
    HeaderBar,
    BusInfoCard,
    StopMap,
    BusStopMapDialog,
    LoadingPage,
  },
  setup() {
    const cityList = taiwanCity;
    const route = useRoute();
    const router = useRouter();
    const currentCityZhtw = ref<string>('');
    const busRoutes = ref<IBusStopOfRoute[]>([]);
    const allBusRoutesInfo = ref<IBusRoute[]>([]);
    const currentBusStopAllRoutesInfo = ref<IBusRoute[]>([]);
    const currentBusStopPostion = ref<ILatLngLiteral>({
      lat: 0,
      lng: 0
    });
    const isShowStopMap = ref<boolean>(false);
    const { city, stopName } = route.params;
    const isLoading = ref<boolean>(true);

    const getOneCityAllBusRoute = async(city: string) => {
      try {
        const res = await busHandler.getOneCityAllBusRouteInfo(city);
        if (res) {
          allBusRoutesInfo.value = res.data;
        }
      } catch (error) {
        console.log(error);
      }
    };
    const getCurrentCity = (cityEnglishName: string) => {
      cityList.forEach((cityObj: City) => {
        if (cityEnglishName === cityObj.value) {
          currentCityZhtw.value = cityObj.name;
        }
      });
    };

    const getBusRouteByBusStop = async() => {
      try {
        const res = await busHandler.getBusStopOfRoutesByBusStop(city as string, stopName as string);
        if (res) {
          busRoutes.value = res.data;
        }
      } catch (error) {
        console.log(error)
      }
    };

    const getCurrentBusStopRouteInfo = async() => {
      currentBusStopAllRoutesInfo.value = busRoutes.value.reduce((result: any[], route: any) => {
        for (let info of allBusRoutesInfo.value) {
          if (route.RouteUID === info.RouteUID) {
            result.push(info);
          }
        }
        return result;
      }, [])
    };

    const findBusRoute = (routeName: string) => {
      router.push(`/find-bus-route/${city}/${routeName}`);
    };

    const getBusStopPosition = async() => {
      try {
        isLoading.value = true;
        const res = await busHandler.getOneBusStopInfo(city as string, stopName as string);
        if (res) {
          const {PositionLon, PositionLat} = res.data[1].StopPosition;
          currentBusStopPostion.value = {
            lat: PositionLat as number,
            lng: PositionLon as number,
          };
        }
        isLoading.value = false;
      } catch (error) {
        console.log(error);
        isLoading.value = false;
      }
    };

    const sharePageInfo = () => {
      const string = `查看等等公車的${currentCityZhtw.value} ${stopName}站牌 即時資訊： https://jolinhappy.github.io/find-bus-app/#${route.fullPath}`
      navigator.clipboard.writeText(string)
      Toast.fire({
        icon: 'success',
        title: '太棒了！ 複製成功！'
      });
    };

    const goUseGps = () => {
      window.open(`https://www.google.com/maps/dir/${currentBusStopPostion.value.lat},${currentBusStopPostion.value.lng}`);
    };

    onMounted(async() => {
      await getOneCityAllBusRoute(city as string);
      await getBusRouteByBusStop();
      getCurrentBusStopRouteInfo();
      getBusStopPosition();
    });
    return {
      getOneCityAllBusRoute,
      getCurrentCity,
      findBusRoute,
      sharePageInfo,
      goUseGps,
      busRoutes,
      currentCityZhtw,
      stopName,
      currentBusStopAllRoutesInfo,
      currentBusStopPostion,
      isShowStopMap,
      city,
      isLoading,
    }
  },
  created() {
    this.getCurrentCity(this.city as string);
  }
});
